import React from 'react'
import { PlaceholderView } from '../PlaceholderView'

export const ReportsMobilePlaceholder = () => {
  return <PlaceholderView prefix="feature.placeholder.reports" />
}
